import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";

export type CommandButtonProps = Omit<ButtonProps, "size">;

export const CommandButton: React.FC<CommandButtonProps> = (
  props: CommandButtonProps
) => {
  return <Button {...props} size="medium" />;
};
